module.exports = __webpack_public_path__ + "static/media/icon_arrow_selected.fbcd6d43.svg";